import * as t from 'io-ts';
import { withFallback } from 'io-ts-types/lib/withFallback';
import { localesUnionType, formLocalesUnionType } from '@/types';

export const profileUpdatingUser = t.type({
  name: t.string,
  email: t.string,
  phoneNumber: withFallback(t.string, ''),
  notificationEmail: withFallback(t.string, ''),
  locale: localesUnionType,
  timezone: t.string,
  timezoneId: t.string,
  formTranslationsLocale: withFallback(t.union([formLocalesUnionType, t.null]), null),
});
